import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2e8d55a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ip-videos"
}

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useIp, useInfo } from '@/store';
import Videos from '../base/Videos.vue';
import { filterVideos } from '@/hooks/useFilterVideos';

export default /*#__PURE__*/_defineComponent({
  __name: 'CgVideos',
  setup(__props) {

_useCssVars(_ctx => ({
  "02358b9f": (_unref(mask).pc)
}))

const { cgVideos, chosenIpVideo, chosenIpVideoIndex } = storeToRefs(useIp());
const { chooseIpVideo, chooseIpVideoIndex } = useIp();

const filteredVideos = filterVideos(cgVideos.value);
chooseIpVideo(filteredVideos[0]);

const { getImg } = useInfo();
const mask = computed(() => ({
  pc: `url(${getImg('ip_pc_around_mask')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(cgVideos).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(Videos, {
          videos: _unref(filteredVideos),
          "choesn-video": _unref(chosenIpVideo),
          "choesn-video-index": _unref(chosenIpVideoIndex),
          onChooseVideo: _unref(chooseIpVideo),
          onChooseVideoIndex: _unref(chooseIpVideoIndex)
        }, null, 8, ["videos", "choesn-video", "choesn-video-index", "onChooseVideo", "onChooseVideoIndex"])
      ]))
    : _createCommentVNode("", true)
}
}

})